import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsJobParser } from "@/models/admin/warrantsJob/warrantsJob.parser"
import { IWarrantsJob } from "@/models/admin/warrantsJob/warrantsJob.types"
import {
  Financials_Warrants_Job_Bool_Exp,
  Financials_Warrants_Job_Order_By,
  GetWarrantsJobsQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsJobListResult {
  jobs: IWarrantsJob[]
  totalCount: number
}

class WarrantsJobServiceClass {
  getJobs(
    search: string,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Job_Order_By,
  ): QueryResult<WarrantsJobListResult> {
    // Jobs are searched by their numeric ID. A non-numeric search can never
    // match a bigint id, so fall back to a sentinel that returns no rows.
    const where: Financials_Warrants_Job_Bool_Exp = {}
    const trimmed = search.trim()
    if (trimmed) {
      where.id = { _eq: /^\d+$/.test(trimmed) ? trimmed : -1 }
    }

    return useQuery({
      ...HasuraQueries.warrants.jobs(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { jobs: [], totalCount: 0 },
      parserFn: (data: GetWarrantsJobsQuery): WarrantsJobListResult => ({
        jobs: data.financials_warrants_job.map(WarrantsJobParser.toDomain),
        totalCount:
          data.financials_warrants_job_aggregate.aggregate?.count ?? 0,
      }),
    })
  }
}

export const WarrantsJobService = new WarrantsJobServiceClass()
